import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { EldForm } from "./EldForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IEldCreateProps {}

export const EldEdit = (props: IEldCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.EldDevice,
    (x) => x.edit
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-elds.title.edit">
        <EldForm />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
